import React from "react";
import SEO from "../components/seo";
import Slider from "react-slick";
import "../stylesheets/main.css";
import "../stylesheets/speaker.css";
import { Wavy } from "../components/wavy";
import { Notification } from "../components/notification";
import NavDrawer from "../components/navdrawer";
import config from "../config";
import { services } from "../util";

export const shapes = [
	<svg width="50px" height="51px" viewBox="0 0 50 51" version="1.1">
		<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g transform="translate(-998.000000, -2031.000000)" stroke="#FF7676" strokeWidth="3">
				<g id="Group-4" transform="translate(974.000000, 1873.000000)">
					<path
						d="M30.0043912,164.799444 L30.0043912,202.166935 L67.3718824,202.166935 L67.3718824,164.799444 L30.0043912,164.799444 Z"
						id="Rectangle"
						transform="translate(48.688137, 183.483190) rotate(-15.000000) translate(-48.688137, -183.483190) "
					/>
				</g>
			</g>
		</g>
	</svg>,
	<svg width="51px" height="55px" viewBox="0 0 51 55" version="1.1">
		<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g transform="translate(-184.000000, -1954.000000)" stroke="#7BABFF" strokeWidth="3">
				<polygon
					id="Triangle"
					transform="translate(220.580835, 1974.292339) rotate(35.000000) translate(-220.580835, -1974.292339) "
					points="220.580835 1952.79234 245.580835 1995.79234 195.580835 1995.79234"
				/>
			</g>
		</g>
	</svg>,
	<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1">
		<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g transform="translate(-227.000000, -2034.000000)" stroke="#FFF18B" strokeWidth="3">
				<circle id="Oval" cx="251" cy="2058" r="22" />
			</g>
		</g>
	</svg>
];

var slicksettings = {
	dots: false,
	infinite: true,
	speed: 500,
	autoplay: true,
	autoplaySpeed: 2500,
	arrows: false,
	slidesToShow: 1,
	variableWidth: true
};
const speakerGrid = data => (
	<Slider {...slicksettings}>
		{data.map((speaker, index) => (
			<div className={"speaker-container"} key={index}>
				<div className={"dp-container"}>
					<div className={"shape"}>{shapes[index % shapes.length]}</div>
					<img alt={speaker.name} className={"speaker-dp"} src={speaker.dp} />
				</div>

				<h3>{speaker.name}</h3>
				<h4>{speaker.designation}</h4>
				<p className={"speaker-desc"}>{speaker.desc}</p>
			</div>
		))}
	</Slider>
);
class IndexPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = { showModal: false, enableSlick: false };
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentDidMount() {
		this.setState({ enableSlick: true });
		var canvas = document.querySelector("canvas");
		var context = canvas.getContext("2d");
		var width = (canvas.width = window.innerWidth);
		var height = (canvas.height = window.innerHeight);

		var waves = [];
		// Change these for more waves or bigger waves
		const count = 3;
		const waveHeight = 50;
		var colors = ["#072C50", "#09335B", "#072541"];

		init();

		// ************************

		function init() {
			// Create the waves
			for (let i = 0; i < count; i++) {
				createWave(colors[i], 5);
			}
			requestAnimationFrame(update);
		}

		function update() {
			context.fillStyle = "#0B3B64";
			context.globalCompositeOperation = "source-over";
			context.fillRect(0, 0, width, height);

			// context.globalCompositeOperation = "screen";
			// Draw waves
			for (let i = 0; i < waves.length; i++) {
				for (let j = 0; j < waves[i].nodes.length; j++) {
					bounce(waves[i].nodes[j]);
				}
				drawWave(waves[i]);
			}
			requestAnimationFrame(update);
		}

		function createWave(color, nodes) {
			var nodeArray = [];
			for (let i = 0; i <= nodes + 2; i++) {
				// Each node is a set of four points
				var node = [((i - 1) * width) / nodes, 0, Math.random() * 200, 0.3];
				nodeArray.push(node);
			}
			waves.push({
				color: color,
				nodes: nodeArray
			});
		}

		function bounce(node) {
			// We change the value of the quadratic pull for each point to move the line
			node[1] = (waveHeight / 2) * Math.sin(node[2] / 20) + height / 2;
			node[2] = node[2] + node[3];
		}

		function drawWave(wave) {
			var diff = function(a, b) {
				return (b - a) / 2 + a;
			};
			context.fillStyle = wave.color;
			context.beginPath();
			context.moveTo(0, height);
			context.lineTo(wave.nodes[0][0], wave.nodes[0][1]);
			for (let i = 0; i < wave.nodes.length; i++) {
				if (wave.nodes[i + 1]) {
					context.quadraticCurveTo(
						wave.nodes[i][0],
						wave.nodes[i][1],
						diff(wave.nodes[i][0], wave.nodes[i + 1][0]),
						diff(wave.nodes[i][1], wave.nodes[i + 1][1])
					);
				} else {
					context.lineTo(wave.nodes[i][0], wave.nodes[i][1]);
					context.lineTo(width, height);
				}
			}

			context.closePath();
			context.fill();
		}
	}

	handleChange(event) {
		const target = event.target;
		const value = target.value;
		const name = target.name;
		this.setState({ [name]: value });
	}

	handleSubmit(event) {
		event.preventDefault();
		const { emailId, name } = this.state;
		services.addInterest(emailId, name);
		this.setState({ showModal: false });
	}

	render() {
		const { showModal, enableSlick } = this.state;
		return (
			<>
				<SEO title="Devfest" />
				{ false && <Notification
					header={"Limited Tickets"}
					subheader={"Reserve your seat for the conference before its too late."}
					cta={"Book Now"}
					link={"/speakers"}
				/> }
				<canvas id="canvas">Hello</canvas>
				<NavDrawer>
					<main>
						{showModal && (
							<div
								className={"overlay"}
								onClick={() => {
									this.setState({ showModal: false });
								}}
							/>
						)}
						{showModal && (
							<div className={"modal"}>
								<h4>Subscribe to get notification when Registrations are open. </h4>
								<br />
								<form onSubmit={this.handleSubmit}>
									<input required name="name" type="text" placeholder={"your name"} value={this.state.name} onChange={this.handleChange} />
									<input
										required
										name="emailId"
										type="email"
										placeholder={"your email"}
										value={this.state.email}
										onChange={this.handleChange}
									/>
									<input type="submit" value="Submit Now!" />
								</form>
							</div>
						)}

						<section className="hero fadeInUpLite">
							<div className="hero-content">
								<img
									alt={"logo"}
									className="logo"
									src="https://res.cloudinary.com/ddbxzcb7k/image/upload/v1562762246/devfesttextlogo_h4m28u.svg"
								/>
								<div className="org-logos">
									<img alt={"logo"} src="https://res.cloudinary.com/ddbxzcb7k/image/upload/v1562743132/gdglogovector_zbui4c.svg" />
									<img alt={"logo"} src="https://www.womentechmakers.com/static/images/priority/wtm-logo-horiz-ko-rgb.svg" />
									<img alt={"logo"} src="https://res.cloudinary.com/ddbxzcb7k/image/upload/v1565879776/gcdclogo-01_f7zx2e.png" />
								</div>
								<h4 className={"date"}> 21 & 22 September —— Bangalore, India </h4>
								<h1>
									Take a Dive in <br /> The Developer Universe
								</h1>
								<p>
									🤩 DevFests are community-led, developer events hosted by GDG chapters around the globe focused on community building and
									learning about Google’s technologies. Each DevFest is inspired by and uniquely tailored to the needs of the developer
									community and region that hosts it.
								</p>
								{ false && <a href="https://konfhub.com/devfest2019" target={"_blank"}>
									<button className="cta">Register Now </button>
								</a> }
							</div>

							<img
								alt={"GDG Devfest"}
								className="hero-image"
								src={"https://res.cloudinary.com/ddbxzcb7k/image/upload/v1564332826/devfest-spacex-02_iitekf.png"}
							/>
						</section>
						<section className="fadeInUpLite highlight-section">
							<article className="right-content-block fadeInUp">
								<h2>Success Story</h2>
								<p>
									Our mission is to bring <i>world-class</i> conference experience to Bangalore every year. DevFest 2018 was concluded on
									October 13, 2018 at the <i>Lalit Ashok, Bangalore</i>. The event embarked the sprit of community and development.
								</p>
							</article>
							<div className={"highlights-container"}>
								<div className={"highlights"}>
									<div className={"highlight-container"}>
										<div className={"key"}>1.5k+</div>
										<div className={"sub"}>Registrations</div>
										<Wavy name={"reg"} />
									</div>
									<div className={"highlight-container"}>
										<div className={"key"}>15+</div>
										<div className={"sub"}>Speakers</div>
										<Wavy name={"spk"} />
									</div>
									<div className={"highlight-container"}>
										<div className={"key"}>7.5k+</div>
										<div className={"sub"}>Meetup Members</div>
										<Wavy name={"met"} />
									</div>
									<div className={"highlight-container"}>
										<div className={"key"}>8+</div>
										<div className={"sub"}>Consecutive Years</div>
										<Wavy name={"con"} />
									</div>
								</div>
								<h4 style={{ color: "#3b6184" }}>(Harmless show off)</h4>
							</div>
						</section>
						
						<section className="speakers-section">
							<h2>Rockstar Speakers</h2>
							{enableSlick && speakerGrid(config.content.cohorts[0].speakers)}
						</section>
						
						<section className="partners">
							<h3> Powered By</h3>
							<div className="powered-by">
								<img alt="Google Logo" src="https://res.cloudinary.com/ddbxzcb7k/image/upload/v1564328299/google_PNG19644_ldk5jy.png"></img>
							</div>
							<br />
							<br />
							<h3> Our Event Sponsors</h3>
							<div className="sponsors">
								<img alt="Bounce Logo" src="https://res.cloudinary.com/ddbxzcb7k/image/upload/v1566398607/bounce_odem4c.png"></img>
								<img
									alt="Elastic Logo"
									src="https://res.cloudinary.com/ddbxzcb7k/image/upload/v1564327509/elastic-logo-H-full-color-reverse_vo1vr3.png"></img>
							</div>
							<h4>& more awesome partners joining us!</h4>
							<br />
							<a href="mailto:sponsor.devfest@gmail.com?Subject=Devfest2019%20Bangalore" target="_top">
								<button className={"cta"}>Join Us</button>
							</a>
						</section>
						<section className="content-block-container left">
							<div
								style={{
									backgroundImage: `linear-gradient(to bottom, rgba(245, 246, 252, 0), #072541),
							url(https://res.cloudinary.com/ddbxzcb7k/image/upload/v1562406407/D9kRjiBVAAAoxah_iy6swi.jpg)`
								}}
								className="image-container"
							/>
							<article className="left-content-block fadeInUp">
								{/* <div className="random-circle" /> */}
								<h2>
									What you need to know,
									<br /> Before you ask.
								</h2>
								<p>
									What is <b>DevFest</b>? Google Developer Group DevFests are the largest Google related events in the world! Each DevFest is
									carefully crafted for you by your local GDG community to bring in awesome speakers from all over the world, great topics,
									and lots fun!
								</p>
							</article>
						</section>
						<section className="content-block-container right fadeInUp">
							<article className="right-content-block">
								<h2>
									Last Year
									<br /> It was <i>Spectacular!</i>
								</h2>
								<p>
									GDG DevFest 2018 highlighted the technical aspects of various product areas such as Cloud, Machine Learning and Data
									Science, Android, Flutter, Firebase, Google Assistant and Mobile Web. <br /> Last year's theme was inspired by the
									traditional but stylish Warli art form. A powerful, art form mesmerized one and all through its traditional artwork
									amplifying the community aspects and bonding.
								</p>
								{ false && <a href="https://konfhub.com/devfest2019" target={"_blank"}>
									<button className="cta">Be a part this year</button>
								</a>}
							</article>
							<iframe
								title={"devfest video"}
								id={"devfest-video"}
								className="content-block-container right fadeInUp"
								color="white"
								src="https://www.youtube.com/embed/cWdKPhf6WVA"
								frameBorder="0"
								allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
								allowFullScreen
							/>
						</section>
						<section className="content-block-container left">
							<div
								style={{
									backgroundImage: `linear-gradient(to bottom, rgba(245, 246, 252, 0), #072541),
							url(https://res.cloudinary.com/ddbxzcb7k/image/upload/v1564331304/Screen_Shot_2019-07-28_at_9.57.57_PM_jb3tvm.png)`
								}}
								className="image-container"
							/>
							<article className="left-content-block fadeInUp">
								{/* <div className="random-circle" /> */}
								<h2>
									This Year
									<br /> It's Double Fun!
								</h2>
								<p>Last year we had an overwhelming response so we decided to make a two day event this year.</p>
								<p>
									<b>Day 1</b> has been designed for professionals with industry experience. Engage in sessions that will give you an insight
									on whats happening new in the Google Developer Ecosystem
								</p>
								<p>
									<b>Day 2</b> is specially designed for students & freshers. Engage in sessions/talks that will help you onboard with latest
									Google Technologies. Connect with Startups & experts.
								</p>
								{ false && <a href="https://konfhub.com/devfest2019" target={"_blank"}>
									<button className="cta">Register Now</button>
								</a> }
							</article>
						</section>
						<section className="organizers">
							<h2>Super Organizers</h2>
							<div className="organizers-list">
								<article>
									<img
										alt={"logo"}
										src="https://res.cloudinary.com/ddbxzcb7k/image/upload/v1562743132/gdglogovector_zbui4c.svg"
										style={{ margin: "10px 0" }}
									/>
									<p>
										To put it in a nutshell, GDG stands for Google Developer Group and GDG Bangalore it is a community where programmers
										meet to discuss and work with several Google developer resources and products.
									</p>
								</article>
								<article>
									<img
										alt={"logo"}
										src="https://www.womentechmakers.com/static/images/priority/wtm-logo-horiz-ko-rgb.svg"
										style={{ width: "280px", margin: "8px 0" }}
									/>
									<p>
										Google’s Women Techmakers program provides visibility, technical skills and resources for women in technology. It is a
										community that celebrates diversity in the technology space.
									</p>
								</article>

								<article>
									<img
										alt={"logo"}
										src="https://res.cloudinary.com/ddbxzcb7k/image/upload/v1565879776/gcdclogo-01_f7zx2e.png"
										style={{ width: "250px" }}
									/>
									<p>
										We are passionate community of Google Cloud Infrastructure Engineers, Architects, generic users, technology evangelists.
									</p>
								</article>
							</div>
						</section>
						<footer>
							<h3> Connect with Us</h3>
							<div
								className={"flex"}
								style={{
									alignItems: "center",
									width: "100%",
									justifyContent: "center"
								}}>
								<div className={"orgs"}>
									<div className={"org-social"}>
										<h4> Sponsorship </h4>
										<a href="mailto:sponsor.devfest@gmail.com?Subject=Devfest2019%20Bangalore" target="_top">
											<div>
												<i className="fas fa-envelope green" /> sponsor.devfest@gmail.com
											</div>
										</a>
										<a href="http://bit.ly/devfest-bangalore-2019-sponsorship" target={"_blank"}>
											<div>Know More</div>
										</a>
										{/* <div>
									<i class="fas fa-phone" />
									+91 9843771996
								</div> */}
									</div>
									<div className={"org-social"}>
										<h4> GDG Bangalore </h4>
										<a href="https://twitter.com/GDGBLR" target={"_blank"}>
											<div>
												<i className="fab fa-twitter green" /> <span className={"link"}>Follow on Twitter</span>
											</div>
										</a>
										<a href="https://www.meetup.com/GDGBangalore/" target={"_blank"}>
											<div>
												<i className="fab fa-meetup green" />
												<span className={"link"}>Join on Meetup</span>
											</div>
										</a>
									</div>
									<div className={"org-social"}>
										<h4> WTM Bangalore </h4>
										<a href="https://twitter.com/wtmblr" target={"_blank"}>
											<div>
												<i className="fab fa-twitter green" /> <span className={"link"}>Follow on Twitter</span>
											</div>
										</a>
										<a href="https://www.meetup.com/GDGBangalore/" target={"_blank"}>
											<div>
												<i className="fab fa-meetup green" />
												<span className={"link"}>Join on Meetup</span>
											</div>
										</a>
									</div>
									<div className={"org-social"}>
										<h4> GCDC Bangalore </h4>
										<a href="https://twitter.com/gcdcblr" target={"_blank"}>
											<div>
												<i className="fab fa-twitter green" /> <span className={"link"}>Follow on Twitter</span>
											</div>
										</a>
										<a href="https://www.meetup.com/gcdcblr/" target={"_blank"}>
											<div>
												<i className="fab fa-meetup green" />
												<span className={"link"}>Join on Meetup</span>
											</div>
										</a>
									</div>
								</div>
							</div>
						</footer>
					</main>
				</NavDrawer>
			</>
		);
	}
}

export default IndexPage;
